import { createContext, useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";

const ThemeContext = createContext({ isDark: false, toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try { return localStorage.getItem("wonstep_theme") === "dark"; }
    catch { return false; }
  });

  useEffect(() => {
    if (isDark) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
    try { localStorage.setItem("wonstep_theme", isDark ? "dark" : "light"); }
    catch {}
  }, [isDark]);

  const toggleTheme = (e) => {
    // Set ripple origin from button position if event provided
    if (e?.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = Math.round((rect.left + rect.width / 2) / window.innerWidth * 100);
      const y = Math.round((rect.top + rect.height / 2) / window.innerHeight * 100);
      document.documentElement.style.setProperty('--reveal-x', x + '%');
      document.documentElement.style.setProperty('--reveal-y', y + '%');
    }

    // Tell CSS which direction we're going
    document.documentElement.dataset.transitioning = isDark ? 'to-light' : 'to-dark';

    if (!document.startViewTransition) {
      setIsDark(d => !d);
      return;
    }
    document.startViewTransition(() => {
      flushSync(() => setIsDark(d => !d));
    });
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
